// src/components/PaywallModal.jsx
//
// Shows a modal overlay when a user tries to access a premium lesson.
// They can close it and go back to browsing freely.
// No hard redirect — much better UX.

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PaywallModal({ onClose }) {
  const navigate  = useNavigate();
  const { user }  = useAuth();

  function handleUpgrade() {
    navigate('/pricing');
    onClose();
  }

  function handleLogin() {
    navigate('/login');
    onClose();
  }

  // Close modal when clicking dark overlay behind it
  function handleOverlayClick(e) {
    if (e.target === e.currentTarget) onClose();
  }

  return (
    <div
      onClick={handleOverlayClick}
      style={{
        position:        'fixed',
        inset:           0,
        backgroundColor: 'rgba(0,0,0,0.85)',
        zIndex:          1000,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        padding:         '24px',
        backdropFilter:  'blur(4px)',
      }}
    >
      <div style={{
        backgroundColor: '#111111',
        border:          '1px solid rgba(255,255,255,0.1)',
        borderRadius:    '20px',
        padding:         '36px',
        maxWidth:        '440px',
        width:           '100%',
        position:        'relative',
      }}>

        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position:        'absolute',
            top:             '16px',
            right:           '16px',
            background:      'rgba(255,255,255,0.06)',
            border:          '1px solid rgba(255,255,255,0.1)',
            borderRadius:    '8px',
            color:           '#9ca3af',
            width:           '32px',
            height:          '32px',
            cursor:          'pointer',
            fontSize:        '16px',
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
          }}
        >
          ✕
        </button>

        {/* Lock icon */}
        <div style={{ fontSize: '40px', marginBottom: '16px' }}>🔒</div>

        {/* Heading */}
        <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#fff', marginBottom: '10px' }}>
          This lesson is premium
        </h2>

        {/* Description */}
        <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: 1.7, marginBottom: '24px' }}>
          You've completed the free modules — great progress! Unlock all 7 remaining
          modules, 39 lessons, the trade journal, and lifetime access for a one-time payment.
        </p>

        {/* What they get */}
        <div style={{ backgroundColor: 'rgba(16,185,129,0.06)', border: '1px solid rgba(16,185,129,0.15)', borderRadius: '12px', padding: '16px', marginBottom: '24px' }}>
          {[
            'Modules 04–10 (39 lessons)',
            'Market Structure, Patterns & Indicators',
            'Risk Management & Trading Psychology',
            'Trade journal with equity curve',
            'Certificate of completion',
            'Lifetime access + future updates',
          ].map((item, i) => (
            <div key={i} style={{ display: 'flex', gap: '8px', alignItems: 'center', fontSize: '13px', color: '#9ca3af', marginBottom: i === 5 ? 0 : '8px' }}>
              <span style={{ color: '#10b981', flexShrink: 0 }}>✓</span>
              {item}
            </div>
          ))}
        </div>

        {/* Price */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <span style={{ fontSize: '32px', fontWeight: 700, color: '#fff' }}>$49</span>
          <span style={{ fontSize: '16px', color: '#4b5563', textDecoration: 'line-through', marginLeft: '10px' }}>$149</span>
          <div style={{ fontSize: '12px', color: '#4b5563', marginTop: '4px' }}>One-time · Lifetime access · 7-day refund</div>
        </div>

        {/* CTA buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button onClick={handleUpgrade} style={{
            width:           '100%',
            padding:         '13px',
            borderRadius:    '10px',
            backgroundColor: '#10b981',
            color:           '#fff',
            border:          'none',
            fontSize:        '15px',
            fontWeight:      600,
            cursor:          'pointer',
          }}>
            Unlock full course →
          </button>

          {!user && (
            <button onClick={handleLogin} style={{
              width:           '100%',
              padding:         '11px',
              borderRadius:    '10px',
              backgroundColor: 'transparent',
              color:           '#9ca3af',
              border:          '1px solid rgba(255,255,255,0.1)',
              fontSize:        '13px',
              cursor:          'pointer',
            }}>
              Already bought? Log in
            </button>
          )}

          <button onClick={onClose} style={{
            width:           '100%',
            padding:         '11px',
            borderRadius:    '10px',
            backgroundColor: 'transparent',
            color:           '#4b5563',
            border:          'none',
            fontSize:        '13px',
            cursor:          'pointer',
          }}>
            Maybe later — go back
          </button>
        </div>
      </div>
    </div>
  );
}